import { VariantTemplate } from '../../dashboard/components/BatchesRouter/types';

export const DEFAULT_FILTER = {
  enabled: 'true',
  inStock: 'true',
};

export interface Location {
  id: number;
  name: string;
}

export interface BatchesState {
  refreshKey: number;
  context: Record<string, any>;
  filters: Record<string, string>;
  isBatchesUpdating: boolean;
  isStockLocations: boolean;
  stockLocations: Location[] | null;
  isCategoriesLoading: boolean;
  categories: any[] | null;
  variantTemplates: VariantTemplate[] | null;
  isModalLoading: boolean;
  template: VariantTemplate | null;
  downloadedTemplate: VariantTemplate | null;
  isTemplateLoading: boolean;
  variantSelectedProducts: Record<string, string>;
}

const batchesState: BatchesState = {
  refreshKey: 0,
  context: null,
  filters: DEFAULT_FILTER,
  isBatchesUpdating: false,
  isStockLocations: false,
  stockLocations: null,
  isCategoriesLoading: false,
  categories: null,
  variantTemplates: null,
  isModalLoading: false,
  template: null,
  downloadedTemplate: null,
  isTemplateLoading: false,
  variantSelectedProducts: {},
};

export default batchesState;